import {
  ChangeDetectionStrategy,
  Component,
  Input,
  ViewEncapsulation,
} from '@angular/core';
import { Params } from '@angular/router';
import { SharedModule } from '../../../shared.module';
import { WidgetNumberDisplayComponent } from '../widget-number-display/widget-number-display.component';

@Component({
  selector: 'app-widget-tickets-display',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  imports: [WidgetNumberDisplayComponent, SharedModule],
  template: `
    <app-widget-number-display
      [status]="'OPEN'"
      [number]="ticketCount"
      [label]="ticketCount || 0 | pluralize: 'Ticket'"
      [hyperlink]="hyperlink"
      [queryParams]="queryParams"
      [ctaText]="'View Tickets'"
      [navigateOnClick]="navigateOnClick"
      [loading]="loading"
    ></app-widget-number-display>
  `,
})
export class WidgetTicketsDisplayComponent {
  @Input() queryParams: Params | null = null;

  @Input() hyperlink: string | null = null;

  @Input() navigateOnClick: boolean = false;

  @Input() ticketCount: number | null = 0;

  @Input() loading: boolean = true;
}
